import { CATEGORY, DataLayer, EVENT, GoogleAnalyticsDataLayer } from 'src/utils/google-analytics'
import { DataHub } from 'src/utils/datahub'
import { BLACK_NOVEMBER_MENU_ID } from '../sidemenu.constants'
import { EventLayer, ImenuItem, IsendToAstroboxWhenUserClickAtIconBN } from './types'

export function sendEventToGa(eventLayer: EventLayer) {
  const dataLayer = new DataLayer(EVENT.INTERACTION, CATEGORY.SIDEMENU, eventLayer.action, eventLayer.label)

  GoogleAnalyticsDataLayer.sendPageInteraction(dataLayer)
}

export const sendToAstroboxWhenUserClickAtIconBN = (
  menuItem: ImenuItem,
  { userId, userType, userSegmentation }: IsendToAstroboxWhenUserClickAtIconBN
) => {
  if (menuItem.id !== BLACK_NOVEMBER_MENU_ID) {
    return void 0
  }
  const EVENT_ENTITY = 'sidemenu'
  const EVENT_ACTION = 'black_november_click'
  const EVENT_SYSTEM = 'app_business_workspace'

  const event = {
    userId,
    userType,
    userSegmentation
  }

  return DataHub.sendDHEvent(EVENT_ENTITY, EVENT_ACTION, event, EVENT_SYSTEM)
}
